var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("page-header-wrapper", [
    _c(
      "div",
      { staticClass: "merchant-dashboard-container" },
      [
        _c("merchant-overview", {
          attrs: { "stats-data": _vm.mergedOverviewData },
        }),
        _c(
          "div",
          { staticClass: "dashboard-section" },
          [
            _c(
              "a-space",
              {
                staticStyle: { width: "100%" },
                attrs: { direction: "vertical", size: 24 },
              },
              [
                _c(
                  "a-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c(
                      "a-col",
                      { attrs: { span: 24 } },
                      [
                        _c("order-count-chart", {
                          attrs: { "chart-data": _vm.chartData.orderCount },
                          on: {
                            handleOrderCountTypeChange:
                              _vm.handleOrderCountTypeChange,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c(
                      "a-col",
                      { attrs: { span: 24 } },
                      [
                        _c("order-distribution-chart", {
                          attrs: {
                            "chart-data": _vm.chartData.orderDistribution,
                          },
                          on: {
                            handleOrderTypeChange: _vm.handleOrderTypeChange,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c(
                      "a-col",
                      { attrs: { span: 24 } },
                      [
                        _c("success-rate-chart", {
                          attrs: { "chart-data": _vm.chartData.successRate },
                          on: {
                            handleSucRateTypeChange:
                              _vm.handleSucRateTypeChange,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c(
                      "a-col",
                      { attrs: { span: 24 } },
                      [
                        _c("order-seven-trend", {
                          attrs: { "chart-data": _vm.chartData.sevenDaysTrend },
                          on: {
                            handleSevenTrendTypeChange:
                              _vm.handleSevenTrendTypeChange,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }